import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { Header } from '../components/layout/Header';
import { UserManagement } from '../components/admin/UserManagement';
import { ThemeManagement } from '../components/admin/ThemeManagement';

export function AdminPage() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState<'users' | 'themes'>('users');

    useEffect(() => {
        if (!loading) {
            if (!user) {
                navigate('/login');
            } else {
                // Simple client-side check for demo/admin entitlement
                // Real app would use custom claims or Firestore role check
                // We allow 'demo-user' for the sake of the requested task
                const isAdmin = user.uid === 'demo-user' || user.email?.includes('admin');
                if (!isAdmin) {
                    navigate('/');
                }
            }
        }
    }, [user, loading, navigate]);

    if (loading || !user) {
        return null; // Or loading spinner
    }

    return (
        <div className="min-h-screen bg-zinc-50 pb-20">
            <Header />

            <main className="max-w-6xl mx-auto px-4 pt-28">
                <div className="flex items-center justify-between mb-8">
                    <div>
                        <h1 className="text-4xl font-bold font-hand mb-2">Admin Dashboard</h1>
                        <p className="text-zinc-500">Manage users and themes</p>
                    </div>
                    <div className="bg-white p-1 rounded-xl border-2 border-zinc-200 inline-flex shadow-sm">
                        <button
                            onClick={() => setActiveTab('users')}
                            className={`px-4 py-2 rounded-lg text-sm font-bold transition-all ${activeTab === 'users'
                                    ? 'bg-primary text-white shadow-sm'
                                    : 'text-zinc-600 hover:bg-zinc-100'
                                }`}
                        >
                            User Management
                        </button>
                        <button
                            onClick={() => setActiveTab('themes')}
                            className={`px-4 py-2 rounded-lg text-sm font-bold transition-all ${activeTab === 'themes'
                                    ? 'bg-primary text-white shadow-sm'
                                    : 'text-zinc-600 hover:bg-zinc-100'
                                }`}
                        >
                            Theme Management
                        </button>
                    </div>
                </div>

                {activeTab === 'users' ? <UserManagement /> : <ThemeManagement />}
            </main>
        </div>
    );
}
